// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__nhJRm","mask":"checkbox_mask__D1qtN"};